module.exports = __webpack_public_path__ + "img/worm-die.ede6b2c1.png";